module.exports = __webpack_public_path__ + "img/c++-stencil.775a45dd.svg";